import { render, staticRenderFns } from "./VehicleDwellTimePageTable.vue?vue&type=template&id=4815a332"
import script from "./VehicleDwellTimePageTable.vue?vue&type=script&lang=js"
export * from "./VehicleDwellTimePageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports